<template>
  <div class="get-token-container">
    <a-spin
      :spinning="loading"
      :tip="`${$t('goToOAuth')}`"
      size="large"></a-spin>
  </div>
</template>

<script>

export default {
  data () {
    return {
      loading: true
    }
  },
  created () {
    // debugger
    // 前往统一登录界面，获取token
    this.$store.dispatch('Login').then(authorUrl => {
      // alert(authorUrl)
      this.loading = false
      window.location.href = authorUrl
      return false
    })
  }
}
</script>

<style lang="less" scoped>

  .get-token-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /deep/.ant-spin {
    position: relative;
    z-index: 999;
  }

  .antd-pro-pages-dashboard-analysis-twoColLayout {
    position: relative;
    display: flex;
    display: block;
    flex-flow: row wrap;

    &.desktop div[class^=ant-col]:last-child {
      position: absolute;
      right: 0;
      height: 100%;
    }
  }

  .antd-pro-pages-dashboard-analysis-salesCard {
    height: calc(100% - 24px);
    /deep/ .ant-card-head {
      position: relative;
    }
  }

  .dashboard-analysis-iconGroup {
    i {
      margin-left: 16px;
      color: rgba(0,0,0,.45);
      cursor: pointer;
      transition: color .32s;
      color: black;
    }
  }
  .analysis-salesTypeRadio {
    position: absolute;
    right: 54px;
    bottom: 12px;
  }
</style>
